import { createContext, useContext, useState, ReactNode } from "react";
import CallbackModal from "@/components/CallbackModal";

interface CallbackModalContextType {
  openCallbackModal: () => void;
}

const CallbackModalContext = createContext<CallbackModalContextType>({
  openCallbackModal: () => {},
});

export const useCallbackModal = () => useContext(CallbackModalContext);

export const CallbackModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CallbackModalContext.Provider value={{ openCallbackModal: () => setIsOpen(true) }}>
      {children}
      <CallbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </CallbackModalContext.Provider>
  );
};
